import { render, staticRenderFns } from "./IBLogin.vue?vue&type=template&id=f285b9f4&scoped=true"
import script from "./IBLogin.vue?vue&type=script&lang=js"
export * from "./IBLogin.vue?vue&type=script&lang=js"
import style0 from "./IBLogin.vue?vue&type=style&index=0&id=f285b9f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f285b9f4",
  null
  
)

export default component.exports